<template>
  <div>
    <div
      class="biz-service"
      :style="{
        margin: `0 ${config.margin_num}px`,
        background: `${config.bg_color || 'none'}`,
      }"
    >
      <!-- 没数据时 -->
      <div v-if="config.link_data && config.link_data.length == 0">
        <div
          v-if="config.style_type == 2"
          class="services-item-double-con"
          style="margin: 0 10px 10px"
        >
          <div class="services-item-double-item">
            <div class="img-wra">
              <img
                src="https://img.mockuai.com/tms/2018/1/10/upload_48dfb5b82f032311cb9207f142a95b89.png"
              />
            </div>
            <div style="padding: 10px">
              <span class="title-text-14 text-2-line">商品标题</span>
              <div class="services-item-double-price flex-row-center">
                <span class="price-font-12">¥ 88.88</span>
              </div>
              <div class="item_buy"><span>立即抢购</span></div>
            </div>
          </div>

          <div class="services-item-double-item">
            <div class="img-wra">
              <img
                src="https://img.mockuai.com/tms/2018/1/10/upload_48dfb5b82f032311cb9207f142a95b89.png"
              />
            </div>
            <div style="padding: 10px">
              <span class="title-text-14 text-2-line">商品标题</span>
              <div class="services-item-double-price flex-row-center">
                <span class="price-font-12">¥ 88.88</span>
              </div>
              <div class="item_buy"><span>立即抢购</span></div>
            </div>
          </div>
        </div>

        <div v-else-if="config.style_type == 4">
          <div
            style="
              width: 100%;
              padding: 10px;
              box-sizing: border-box;
              background: #ffffff;
              display: flex;
              margin-bottom: 10px;
            "
          >
            <div class="img-wra style2">
              <img
                src="https://img.mockuai.com/tms/2018/1/10/upload_48dfb5b82f032311cb9207f142a95b89.png"
              />
            </div>
            <div
              style="
                flex: 1;
                margin-left: 10px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
              "
            >
              <div class="title-text-14 text-2-line">商品标题</div>
              <div
                class="flex-row-center"
                style="justify-content: space-between; width: inherit"
              >
                <span class="price-font-12">活动价 </span
                ><span class="price-font-16">¥ 88.88</span>
                <div class="flex-auto"></div>
                <div class="three_buy"><span>立即抢购</span></div>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="config.style_type == 5" style="font-size: 0">
          <div>
            <div class="img-wra style3">
              <img
                src="https://img.mockuai.com/tms/2018/1/10/upload_48dfb5b82f032311cb9207f142a95b89.png"
              />
            </div>
            <div style="background: #ffffff; padding: 10px">
              <div class="title-text-14 text-1-line">商品标题</div>
              <div
                class="flex-row-center"
                style="justify-content: space-between; padding: 10px 0"
              >
                <span
                  ><span class="price-font-12">活动价 </span
                  ><span class="price-font-16">¥ 88.88</span></span
                >
                <div class="three_buy"><span>立即抢购</span></div>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="config.style_type == 6" class="scroll_H">
          <div v-for="n in 4" :key="n">
            <div
              class="scroll_H-item"
              :style="'margin-right:10px;width:102px;'"
            >
              <div>
                <div class="img-wra style4">
                  <img
                    src="https://img.mockuai.com/tms/2018/1/10/upload_48dfb5b82f032311cb9207f142a95b89.png"
                  />
                </div>
                <div class="flex-column-center">
                  <span
                    class="title-text-14 text-1-line"
                    style="line-height: 21px; text-align: left"
                    >商品标题</span
                  >
                  <span class="price-font-12" style="margin-bottom: 5px"
                    >¥ 155.00</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="config.style_type == 7" class="services-item-three-con">
          <div v-for="n in 3" :key="n" class="services-item-three-item">
            <div>
              <div class="services-item-three-img">
                <img
                  src="https://img.mockuai.com/tms/2018/1/10/upload_48dfb5b82f032311cb9207f142a95b89.png"
                />
              </div>
              <div class="flex-column-center">
                <span
                  class="title-text-14 text-1-line"
                  style="line-height: 21px; text-align: left"
                  >商品标题</span
                >
                <span class="price-font-12">¥ 155.00</span>
              </div>
              <div class="three_buy" style="margin: 0 auto 10px">
                <span>立即抢购</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--   有数据时 -->
      <div v-else-if="config.link_data">
        <div v-if="config.style_type == 2">
          <div
            class="services-item-double-con item-2"
            v-for="index in Math.ceil(config.link_data.length / 2)"
            :key="index"
          >
            <div
              class="services-item-double-item"
              @click="jump(config.link_data[(index - 1) * 2])"
            >
              <div class="img-wra">
                <img
                  :src="config.link_data[(index - 1) * 2].icon_url"
                  class="is-live"
                />
              </div>
              <div style="padding: 10px">
                <span class="title-text-14 text-1-line">{{
                  config.link_data[(index - 1) * 2].item_name
                }}</span>
                <!--卖家-->
                <div
                  v-if="app_type == 'seller'"
                  class="services-item-double-price"
                >
                  <div style="color: #ec4000">
                    <p class="price-font-10">预计赚</p>
                    <p class="price-font-num-14 ft500">
                      <span style="font-size: 8px">¥</span
                      >{{
                        config.link_data[(index - 1) * 2].promotion_profit
                          | filterPrice
                      }}
                    </p>
                  </div>
                  <div>
                    <p class="price-font-10">佣金</p>
                    <p class="price-font-num-14 ft500">
                      {{
                        config.link_data[(index - 1) * 2].commission_percent
                      }}%
                    </p>
                  </div>
                  <div>
                    <p class="price-font-10">粉丝购买价</p>
                    <p class="price-font-num-14 ft500">
                      <span style="font-size: 8px">¥</span
                      >{{
                        config.link_data[(index - 1) * 2].market_price
                          | filterPrice
                      }}
                    </p>
                  </div>
                </div>
                <!--买家-->
                <div v-else class="services-item-double-price flex-row-center">
                  <span
                    class="price-font-12"
                    v-if="config.link_data[(index - 1) * 2].sec_kill_mark"
                    >¥
                    {{
                      config.link_data[(index - 1) * 2].sec_kill_price / 100
                    }}</span
                  >
                  <span class="price-font-12" v-else
                    >¥
                    {{
                      config.link_data[(index - 1) * 2].promotion_price / 100
                    }}</span
                  >
                </div>
                <div class="item_buy">
                  <span>{{
                    app_type == "seller" ? "立即上架" : "立即抢购"
                  }}</span>
                </div>
              </div>
            </div>
            <div
              class="services-item-double-item"
              @click="jump(config.link_data[index * 2 - 1])"
              v-if="
                index * 2 < config.link_data.length ||
                ((index * 2) % 2 === 0 && index * 2 === config.link_data.length)
              "
            >
              <div class="img-wra">
                <img
                  :src="config.link_data[index * 2 - 1].icon_url"
                  class="is-live"
                />
              </div>
              <div style="padding: 10px">
                <span class="title-text-14 text-1-line">{{
                  config.link_data[index * 2 - 1].item_name
                }}</span>
                <!--卖家-->
                <div
                  v-if="app_type == 'seller'"
                  class="services-item-double-price"
                >
                  <div style="color: #ec4000">
                    <p class="price-font-10">预计赚</p>
                    <p class="price-font-num-14 ft500">
                      <span style="font-size: 8px">¥</span
                      >{{
                        config.link_data[index * 2 - 1].promotion_profit
                          | filterPrice
                      }}
                    </p>
                  </div>
                  <div>
                    <p class="price-font-10">佣金</p>
                    <p class="price-font-num-14 ft500">
                      {{ config.link_data[index * 2 - 1].commission_percent }}%
                    </p>
                  </div>
                  <div>
                    <p class="price-font-10">粉丝购买价</p>
                    <p class="price-font-num-14 ft500">
                      <span style="font-size: 8px">¥</span
                      >{{
                        config.link_data[index * 2 - 1].market_price
                          | filterPrice
                      }}
                    </p>
                  </div>
                </div>
                <!--买家-->
                <div v-else class="services-item-double-price flex-row-center">
                  <span
                    class="price-font-12"
                    v-if="config.link_data[index * 2 - 1].sec_kill_mark"
                    >¥
                    {{
                      config.link_data[index * 2 - 1].sec_kill_price / 100
                    }}</span
                  >
                  <span class="price-font-12" v-else
                    >¥
                    {{
                      config.link_data[index * 2 - 1].promotion_price / 100
                    }}</span
                  >
                </div>
                <div class="item_buy">
                  <span>{{
                    app_type == "seller" ? "立即上架" : "立即抢购"
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="config.style_type == 4">
          <div
            class="item-4"
            @click="jump(item)"
            v-for="(item, index) in config.link_data"
            :key="index"
          >
            <div class="img-wra style2">
              <img :src="item.icon_url" class="is-live" />
            </div>
            <div
              style="
                flex: 1;
                margin-left: 10px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
              "
            >
              <div class="title-text-14 text-2-line">{{ item.item_name }}</div>

              <!--卖家-->
              <div v-if="app_type == 'seller'">
                <div class="flex-row-center" style="width: inherit">
                  <div class="price-font-12">
                    佣金
                    <span class="price-font-16"
                      >{{ item.commission_percent }}%</span
                    >
                  </div>
                </div>
                <div
                  class="flex-row-center"
                  style="justify-content: space-between; width: inherit"
                >
                  <span class="price-font-12">粉丝购买价</span>
                  <span class="price-font-16">
                    ¥{{ item.market_price / 100 }}</span
                  >
                  <div class="flex-auto"></div>
                  <div class="three_buy"><span>立即上架</span></div>
                </div>
              </div>
              <!--买家-->
              <div
                v-else
                class="flex-row-center"
                style="justify-content: space-between; width: inherit"
              >
                <span class="price-font-12">活动价 </span>
                <span class="price-font-16" v-if="item.sec_kill_mark"
                  >¥ {{ item.sec_kill_price / 100 }}</span
                >
                <span class="price-font-16" v-else
                  >¥ {{ item.promotion_price / 100 }}</span
                >
                <div class="flex-auto"></div>
                <div class="three_buy"><span>立即抢购</span></div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="item-5"
          v-else-if="config.style_type == 5"
          style="font-size: 0"
          @click="jump(item)"
          v-for="(item, index) in config.link_data"
          :key="index"
        >
          <div>
            <div class="img-wra style3">
              <img :src="item.icon_url" class="is-live" />
            </div>
            <div style="background: #ffffff; padding: 10px">
              <div class="title-text-14 text-2-line">{{ item.item_name }}</div>
              <!--卖家-->
              <div v-if="app_type == 'seller'">
                <div class="flex-row-center" style="width: inherit">
                  <div class="price-font-12">
                    佣金
                    <span class="price-font-16"
                      >{{ item.commission_percent }}%</span
                    >
                  </div>
                </div>
                <div
                  class="flex-row-center"
                  style="justify-content: space-between; width: inherit"
                >
                  <span class="price-font-12">粉丝购买价</span
                  ><span class="price-font-16">
                    ¥ {{ item.market_price / 100 }}</span
                  >
                  <div class="flex-auto"></div>
                  <div class="three_buy"><span>立即上架</span></div>
                </div>
              </div>
              <!--买家-->
              <div
                v-else
                class="flex-row-center"
                style="justify-content: space-between; padding: 10px 0"
              >
                <span class="price-font-12"
                  >活动价
                  <span class="price-font-16" v-if="item.sec_kill_mark"
                    >¥ {{ item.sec_kill_price / 100 }}</span
                  >
                  <span class="price-font-16" v-else
                    >¥ {{ item.promotion_price / 100 }}</span
                  >
                </span>
                <div class="three_buy"><span>立即抢购</span></div>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="config.style_type == 6" class="scroll_H">
          <div
            class="scroll_H-item"
            v-for="(service, index) in config.link_data"
            :key="index"
            @click="jump(service)"
          >
            <div>
              <div class="style img-wra style4">
                <img :src="service.icon_url" class="is-live" />
              </div>
              <div class="flex-column-center">
                <span
                  class="title-text-14 text-1-line"
                  style="line-height: 21px; text-align: left; padding-top: 10px"
                  >{{ service.item_name }}</span
                >

                <!--卖家-->
                <div v-if="app_type == 'seller'">
                  <div class="price-font-12">
                    佣金 {{ service.commission_percent }}%
                  </div>
                  <div class="price-font-12" style="margin-bottom: 5px">
                    购买价 ¥ {{ service.market_price / 100 }}
                  </div>
                </div>
                <!--买家-->
                <div v-else>
                  <span class="price-font-12" v-if="service.sec_kill_mark"
                    >¥ {{ service.sec_kill_price / 100 }}</span
                  >
                  <span class="price-font-12" style="margin-bottom: 5px" v-else
                    >¥ {{ service.promotion_price / 100 }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="config.style_type == 7" class="services-item-three-con">
          <div
            v-for="(service, index) in config.link_data"
            :key="index"
            @click="jump(service)"
            class="services-item-three-item"
          >
            <div>
              <div class="services-item-three-img">
                <img :src="service.icon_url" class="is-live" />
              </div>
              <div class="flex-column-center">
                <span
                  class="title-text-14 text-1-line"
                  style="line-height: 21px; text-align: left"
                  >{{ service.item_name }}</span
                >
                <!--卖家-->
                <div v-if="app_type == 'seller'">
                  <div class="price-font-12">
                    佣金 {{ service.commission_percent }}%
                  </div>
                  <div class="price-font-12" style="margin-bottom: 5px">
                    购买价 ¥ {{ service.market_price / 100 }}
                  </div>
                </div>
                <!--买家-->
                <div v-else>
                  <span class="price-font-12" v-if="service.sec_kill_mark"
                    >¥ {{ service.sec_kill_price / 100 }}</span
                  >
                  <span class="price-font-12" style="margin-bottom: 5px" v-else
                    >¥ {{ service.promotion_price / 100 }}</span
                  >
                </div>
              </div>
              <div class="three_buy" style="margin: 0 auto 10px">
                <span>{{
                  app_type == "seller" ? "立即上架" : "立即抢购"
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { redirectURL } from "@/js/jump";
export default {
  name: "tms-biz-item",
  props: ["config", "theme", "isEditorStatus", "pageData"],
  components: {},
  data() {
    return {
      ids: [],
    };
  },
  computed: {
    app_type() {
      return this.pageData.app_type || "seller";
    },
  },
  mounted() {
    const ua = window.navigator.userAgent;
    if (
      this.config.link_data &&
      this.config.link_data.length &&
      (ua.indexOf("Mockuai") > -1 || ua.indexOf("Wdzg") > -1) &&
      this.app_type === "seller"
    ) {
      this.config.link_data.forEach((item) => {
        if (item.id) {
          this.ids.push(item.id);
        }
      });
      this.getGoodList();
    }
  },
  methods: {
    jump(item) {
      if (this.isEditorStatus) {
        return;
      }
      this.$emit("report", {
        btn: "0001",
        type: "u_click",
        params: { item_id: item.id },
      });
      redirectURL(item.id.toString(), this.app_type);
    },
    getGoodList() {
      let newList = [];
      lib.api.get({
        api: "ec/b/operation/item/list",
        data: {
          item_id_list: JSON.stringify(this.ids),
          item_status: 4,
        },
        success: (res) => {
          if (res.data.data && res.data.data.length) {
            this.config.link_data = res.data.data;
          }
        },
        error: (data) => {},
        complete: () => {},
      });
    },
  },
};
</script>
<style  lang="scss" scoped>
@import "./index.scss";
</style>